import './NewsList.scss';
import {fileManager} from '../Constants';
import {json, Link, useNavigate, useParams} from "react-router-dom";
import axiosServise from '../ApiService';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Fab, IconButton, Modal, Typography} from "@mui/material";
import {FavoriteBorder, OpenInNew, ThumbDown, ThumbUp, DateRange, Add, Save, Cancel} from "@mui/icons-material";
import parse from "html-react-parser";
import IranSanse from "../Typography/IranSanse.tsx";
import {useEffect, useState} from "react";
import CKEditor from 'react-ckeditor-component';
import Cookies from 'js-cookie';
import axios from "axios";
import {News2} from "../../Entities/News2.ts";
import FloatIcon from "../FloatIcon/FloatIcon.tsx";

const axiosServise2 = axios.create({
    baseURL: "http://KhorshidPishva.com:8084/",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});
export default function (props) {
    let data;
    let cok;

    const onChange = (evt) => {
        // console.log("onChange fired with event info: ", evt);
        data = evt.editor.getData();
        console.log(data);
    }
    // const editorConfiguration = {
    //     plugins: [ Essentials, Bold, Italic, Paragraph ],
    //     toolbar: [ 'bold', 'italic' ]
    // };
    const config = {
        language: "fa",
        fontFamily: {
            options: [
                'default',
                'Ubuntu, Arial, sans-serif',
                'Ubuntu Mono, Courier New, Courier, monospace'
            ]
        },
    };
    // const [data, setData] = useState('');

    const {newsType} = useParams();
    const [newses, setNewses] = useState<News2[]>([]);
    const [userType, setUserType] = useState('Admin');
    const [totalCountNews, setTotalCountNews] = useState();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        console.log(newsType);

        getNews();
        // window.addEventListener('scroll', handleScroll);
        // return () => window.removeEventListener('scroll', handleScroll);
    }, [rowsPerPage, page, totalCountNews, newsType]) // when page index or pageSize changed -> this component will be rerender and getNews() will call again!
    // let current = localStorage.getItem('CurrentNewsType')
    const [open, setOpen] = useState(false);


    const getNews = async () => {
        try {
            // if (newsType) {
            //     localStorage.setItem('CurrentNewsType', newsType)
            // }
            // current = localStorage.getItem('CurrentNewsType')

            if (props.current === 'Shrine') {
                setIsLoading(true);
                await axiosServise2.post(`News/All`,
                    {
                        "Token": "1",
                        "Entity": {}
                    }
                ).then(
                    response => {
                        setIsLoading(false);
                        console.log(response.data.response);
                        let res: News2[] = response.data.response
                        const x = res.map(r => {
                            const news2 = new News2();
                            news2.ID = r.ID
                            news2.Title = r.Title
                            news2.Text = r.Text
                            news2.SubTitle = r.SubTitle
                            return news2;
                        })
                        setNewses(x);
                        // setNewses(res);
                        console.log(x);
                        console.log(newses);
                        setTotalCountNews(response.data.count);

                    })

            } else if (props.current === 'Plans') {
                setIsLoading(true);
                await axiosServise.get(`Newses?pageIndex=${page}&pageSize=${rowsPerPage}`).then(
                    response => {
                        setIsLoading(false);
                        setNewses(response.data.content);
                        setTotalCountNews(response.data.total);

                    })
            } else if (props.current === 'BasijNews') {
                setIsLoading(true);
                await axiosServise.get(`Newses?pageIndex=${page}&pageSize=${rowsPerPage}`).then(
                    response => {
                        setIsLoading(false);
                        setNewses(response.data.content);
                        setTotalCountNews(response.data.total);

                    })
            } else if (props.current === 'CityNews') {
                setIsLoading(true);
                await axiosServise.get(`Newses?pageIndex=${page}&pageSize=${rowsPerPage}`).then(
                    response => {
                        setIsLoading(false);
                        setNewses(response.data.content);
                        setTotalCountNews(response.data.total);

                    })
            } else if (props.current === 'Khoddam') {
                setIsLoading(true);
                await axiosServise2.post(`News`,
                    {
                        "Token": "1",
                        "Entity": {
                            "Category":{
                                "ID":1
                            }
                        }
                    }
                ).then(
                    response => {
                        setIsLoading(false);
                        console.log(response.data.response);
                        let res: News2[] = response.data.response
                        const x = res.map(r => {
                            const news2 = new News2();
                            news2.ID = r.ID
                            news2.Title = r.Title
                            news2.Text = r.Text
                            news2.SubTitle = r.SubTitle
                            return news2;
                        })
                        setNewses(x);
                        // setNewses(res);
                        console.log(x);
                        console.log(newses);
                        setTotalCountNews(response.data.count);

                    })
            } else {
                localStorage.setItem('CurrentNewsType', 'Shrine')
                // nav('/News/Shrine')
            }
        } catch (err) {
            console.log(err);
        }
    }


    const goToDetail = (id) => {
        nav(`/ShrineNews/ShrineNewsDetail/${id}`)
    }

    return (
        <div className=''>
            <Row className='g-0 mx-0' style={{paddingRight: 20}}>
                <Col className=' mx-0'>
                    <Row style={{justifyContent: "center", display: "flex", paddingBottom: 100}} className='g-0 pt-2'>
                        {newses.map(news => {
                            return (
                                <Col className="marCards g-0">
                                    <div key={news?.ID?.toString()} className='boxNews'>
                                        {
                                            news.pictureId ?
                                                <img className='imgclc' src={`${fileManager}${news.pictureId}`}
                                                     alt="" onClick={() => {
                                                    goToDetail(`${news?.ID}`)
                                                }}/>
                                                :
                                                <img className='akhbar-img' alt=""/>
                                        }
                                        <Row className='g-0'>
                                            <Col className="m-1">
                                                {/*<span> {news.shamsiCreationDate} {news.time} </span>*/}
                                                <IranSanse>
                                                    <DateRange color={"info"}></DateRange>
                                                    <span style={{
                                                        fontSize: 11,

                                                        width: '300px',
                                                        marginTop: 0, paddingRight: 0
                                                    }}> {news.shamsiCreationDate} {news.time} </span>
                                                </IranSanse>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className="mx-2 ">
                                                <IranSanse>
                                                    <textarea className="textAAr3 " disabled={true}
                                                              value={news.Title}>

                                                    </textarea>
                                                </IranSanse>
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col style={{marginRight: 6, marginLeft: 6, marginTop: 2}}>
                                                <div style={{
                                                    overflowWrap: 'break-word',
                                                    position: 'relative',
                                                    textJustify: 'inter-word',
                                                    fontSize: 'small',
                                                    height: '100px',
                                                    width: '305px',
                                                    overflowY: 'scroll',
                                                    overflowX: 'hidden',
                                                    WebkitScrollSnapType: 'x',
                                                    marginBottom: '0',
                                                    paddingLeft: 6,
                                                }}>
                                                    <IranSanse>{parse(news.SubTitle ?? '')}</IranSanse>

                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="pt-0">
                                            <Col className="d-inline-flex">
                                                <div className="iconCircle mx-2" onClick={() => {
                                                }}>
                                                    <IconButton variant="solid" size={"small"}>
                                                        <FavoriteBorder fontSize={"small"} color={"primary"}
                                                                        onClick={() => {
                                                                        }}/>
                                                    </IconButton>
                                                </div>
                                                <div className="iconCircle">
                                                    <IconButton variant="solid" size={"small"}>
                                                        <ThumbUp fontSize={"small"} color={"primary"}/>
                                                    </IconButton>
                                                </div>
                                                <div className="iconCircle mx-2">
                                                    <IconButton variant="solid" size={"small"}>
                                                        <ThumbDown fontSize={"small"} color={"primary"}/>
                                                    </IconButton>
                                                </div>
                                                <div className="iconCircle">
                                                    <IconButton variant="solid" size={"small"}>
                                                        <OpenInNew fontSize={"small"} color={"primary"}
                                                                   onClick={() => {
                                                                       goToDetail(`${news.ID}`)
                                                                   }}/>
                                                    </IconButton>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                </Col>
            </Row>
            <Row className=' g-0 py-3' style={{paddingRight: 20}}>
                <Col className=''>

                </Col>
                <Col className=''>
                    <button className='btn btn-light'
                            onClick={() => setPage(1)}
                            disabled={isLoading || page === 1}
                            style={{borderRadius: '10%'}}
                    >

                        <IranSanse>اولین</IranSanse>
                    </button>
                </Col>
                <Col className=''>
                    <button className='btn btn-light'
                            onClick={() => setPage(page - 1)}
                            disabled={isLoading || page === 1}
                            style={{borderRadius: '10%'}}
                    >
                        <IranSanse>قبلی</IranSanse>

                    </button>
                </Col>
                <Col className=''>
                    <button className='btn btn-light float-start'
                            onClick={() => setPage(page + 1)}
                            disabled={isLoading || newses.length < rowsPerPage}
                            style={{borderRadius: '10%'}}
                    >

                        <IranSanse>بعدی</IranSanse>
                    </button>
                </Col>
                <Col className=''>
                    <button className='btn btn-light float-start'
                            onClick={() => setPage(Math.round(totalCountNews / rowsPerPage) + 1)}
                            disabled={isLoading || page === 1}
                            style={{borderRadius: '10%'}}
                    >

                        <IranSanse>آخرین</IranSanse>
                    </button>
                </Col>
                <Col className=''>

                </Col>
            </Row>

            {
                Cookies.get('auth') ?
                    <div className='floatBTN'>
                        {open ? <div className='bg-danger'>
                                <Row className='bg-info g-0'>
                                    <Col sm={12} md={12} lg={12}
                                         className='d-flex justify-content-center text-white py-4'>
                                        <IranSanse fontSize={20}>متن خبر</IranSanse>
                                    </Col>
                                </Row>
                                <Row className='bg-danger g-0'>
                                    <Col sm={12} md={12} lg={12} className='w-100'>
                                        <CKEditor
                                            activeClass="p10"
                                            config={config}
                                            // content={data}
                                            events={{
                                                // "blur": this.onBlur,
                                                // "afterPaste": this.afterPaste,
                                                "change": onChange
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className='bg-info g-0'>
                                    <Col sm={6} md={6} lg={6}
                                         className='d-flex justify-content-center text-white py-3'>
                                        <Fab onClick={() => {
                                            console.log(data);
                                            fetch("http://KhorshidPishva.com:8084/News/", {
                                                mode: 'cors',
                                                method: 'PUT',
                                                body: JSON.stringify({
                                                    "Token": "1",
                                                    "Entity": {
                                                        "Title": "test",
                                                        "Text": data
                                                    }
                                                })
                                            })
                                            setOpen(false);
                                        }}>
                                            <Save></Save>
                                        </Fab>
                                    </Col>
                                    <Col sm={6} md={6} lg={6}
                                         className='d-flex justify-content-center text-white py-3'>
                                        <Fab onClick={() => {
                                            setOpen(false);
                                        }}>
                                            <Cancel></Cancel>
                                        </Fab>
                                    </Col>
                                </Row>

                            </div> :
                            <div>

                                <FloatIcon onClick={() => {
                                    setOpen(true);
                                }}>
                                    <Add></Add>
                                </FloatIcon>
                            </div>
                        }
                        {/*<Modal className='modalStyle'*/}
                        {/*       onClose={handleClose}*/}
                        {/*       open={open}*/}
                        {/*>*/}

                        {/*</Modal>*/}
                    </div>
                    : <></>
            }
        </div>
    )
}
